import { ExtraWorkAggreementApprovalStatusResponse, GetExtraWorkAgreementQueryResponse } from "api/generatedApi";
import { UseFormGetValues } from "react-hook-form";

export interface ExtraWorkAgreementFormData extends GetExtraWorkAgreementQueryResponse {}

export function useValidateExtraWorkAgreementInput() {
  const isLockedBasedOnState = (getValue: UseFormGetValues<ExtraWorkAgreementFormData>): boolean => {
    const statuses: ExtraWorkAggreementApprovalStatusResponse[] = ["Approved", "Cancelled", "Rejected", "AwaitingApproval"];
    return statuses.indexOf(getValue("approvalStatus")!) > -1;
  };

  const isStateLockedBasedOnState = (getValue: UseFormGetValues<ExtraWorkAgreementFormData>): boolean => {
    const statuses: ExtraWorkAggreementApprovalStatusResponse[] = ["Approved", "Cancelled", "Rejected"];
    return statuses.indexOf(getValue("approvalStatus")!) > -1;
  };

  const hasValidateInputs = (getValue: UseFormGetValues<ExtraWorkAgreementFormData>): boolean => {
    const name = getValue("name");
    const type = getValue("extraWorkAgreementType");
    const payment = getValue("paymentDkr");
    const workHours = getValue("workTime.hours");
    const workMinutes = getValue("workTime.minutes");
    const status = getValue("approvalStatus");

    if (!name || name === "") {
      return false;
    }
    if (!type) {
      return false;
    }
    if (type === "AgreedPayment") {
      if (!payment || payment === 0) {
        return false;
      }
    }
    if (type === "CompanyHours" || type === "CustomerHours") {
      if ((!workHours && !workMinutes) || (workHours === 0 && workMinutes === 0)) {
        return false;
      }
    }

    return true;
  };

  return { hasValidateInputs, isLockedBasedOnState, isStateLockedBasedOnState };
}
